import React, { useEffect, useState } from "react";
import Notification from "../Notification/Notification" // optional for messages

import { acceptFriendRequest, getReceivedRequests,
   rejectFriendRequest } from "../../services/friendService";

import "./FriendRequest.css";

const FriendRequests = ({ token }) => {
  const [requests, setRequests] = useState([]);
  const [notif, setNotif] = useState("");

  // Fetch received friend requests
  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const res = await getReceivedRequests();
        setRequests(res.data); // array of requests
      } catch (err) {
        console.error(err);
        setNotif("Failed to fetch friend requests");
      }
    };

    fetchRequests();
  }, [token]);

 // Accept a friend request
const acceptRequest = async (id) => {
  try {
    await acceptFriendRequest(id);
    setRequests(prev => prev.filter(req => req._id !== id));
    setNotif("Friend request accepted");
    setTimeout(() => setNotif(""), 3000);
  } catch (err) {
    console.error(err.response?.data || err.message);
    setNotif("Failed to accept request");
  }
};

// Reject a friend request
const rejectRequest = async (id) => {
  try {
    await rejectFriendRequest(id);
    setRequests(prev => prev.filter(req => req._id !== id));
    setNotif("Friend request rejected");
    setTimeout(() => setNotif(""), 3000);
  } catch (err) {
    console.error(err.response?.data || err.message);
    setNotif("Failed to reject request");
  }
};

  return (
    <div className="friend-requests">
      <Notification message={notif} onClose={() => setNotif("")} />
      <h3>Friend Requests</h3>
      {requests.length === 0 && <p>No requests</p>}
      {requests.map(req => (
        <div key={req._id} className="request-item">
          <span>{req.username}</span>
          <button onClick={() => acceptRequest(req._id)}>Accept</button>
          <button onClick={() => rejectRequest(req._id)}>Reject</button>
        </div>
      ))}
    </div>
  );
};

export default FriendRequests;
